//
// Copyright (c) 2021 Astute Global, Inc.
//

import { Command } from "ckeditor5";

export default class CreateCustomTemplateCommand extends Command {
  constructor(editor) {
    super(editor);
    this.set("templateName", null);
  }

  execute({ templateName, template } = {}) {
    templateName = templateName || this.templateName;
    if (!templateName) {
      console.error("No template name given to CreateCustomTemplateCommand");
      return;
    }
    template = template || this.value;
    if (!template) {
      console.error("No HTML given to CreateCustomTemplateCommand");
      return;
    }
    // Must only load the MessengerAdapter using its name, cannot import it
    // otherwise the entire Backbone library will get pulled into the build
    if (!this.editor.plugins.has("MessengerAdapter")) {
      console.error(
        "No MessengerAdapter plugin found to Create Custom Template, probably in CK Cloud",
      );
      return;
    }
    const messengerAdapter = this.editor.plugins.get("MessengerAdapter");
    const newCustomTemplate = messengerAdapter.reqres().request("new:custom:template");
    if (newCustomTemplate) {
      newCustomTemplate.set("name", templateName);
      newCustomTemplate.set("template", template);
      newCustomTemplate.save();
    }
  }

  refresh() {
    const model = this.editor.model;
    if (!model || !model.document || !model.document.selection) {
      return false;
    }
    this.isEnabled = !model.document.selection.isCollapsed;
  }
}
